import {
  EmploymentSubType,
  EmploymentSubTypeFullTime,
  EmploymentSubTypeIndividualContractor,
  EmploymentSubTypeIntern,
  EmploymentSubTypePartTime,
  EmploymentSubTypeSeasonal,
  EmploymentSubTypeTemp,
} from "./types";

export const EMPLOYMENT_SUBTYPE_FULL_TIME: EmploymentSubTypeFullTime = "full_time";
export const EMPLOYMENT_SUBTYPE_PART_TIME: EmploymentSubTypePartTime = "part_time";
export const EMPLOYMENT_SUBTYPE_INTERN: EmploymentSubTypeIntern = "intern";
export const EMPLOYMENT_SUBTYPE_TEMP: EmploymentSubTypeTemp = "temp";
export const EMPLOYMENT_SUBTYPE_SEASONAL: EmploymentSubTypeSeasonal = "seasonal";
export const EMPLOYMENT_SUBTYPE_INDIVIDUAL_CONTRACTOR: EmploymentSubTypeIndividualContractor =
  "individual_contractor";
export const EMPLOYMENT_SUBTYPE_MAP: Record<EmploymentSubType, string> = {
  [EMPLOYMENT_SUBTYPE_FULL_TIME]: "Full Time",
  [EMPLOYMENT_SUBTYPE_PART_TIME]: "Part Time",
  [EMPLOYMENT_SUBTYPE_INTERN]: "Intern",
  [EMPLOYMENT_SUBTYPE_TEMP]: "Temporary",
  [EMPLOYMENT_SUBTYPE_SEASONAL]: "Seasonal",
  [EMPLOYMENT_SUBTYPE_INDIVIDUAL_CONTRACTOR]: "Contractor",
};

export const EMPLOYMENT_TYPE_EMPLOYEE = "employee";
export const EMPLOYMENT_TYPE_CONTRACTOR = "contractor";
export const EMPLOYMENT_TYPE_MAP: Record<string, string> = {
  [EMPLOYMENT_TYPE_EMPLOYEE]: "Employee",
  [EMPLOYMENT_TYPE_CONTRACTOR]: "Contractor",
};
